export default __webpack_public_path__ + "static/media/brushed-metal-bg.ebc39d87.png";